import { render, staticRenderFns } from "./page-view.vue?vue&type=template&id=0ab7ccbc&scoped=true"
import script from "./page-view.vue?vue&type=script&lang=js"
export * from "./page-view.vue?vue&type=script&lang=js"
import style0 from "./page-view.vue?vue&type=style&index=0&id=0ab7ccbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab7ccbc",
  null
  
)

export default component.exports